var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { delay, getRandomNumber } from 'ziphy-web-shared/basic/helpers';
export function getFakeMock(prepared) {
    return __awaiter(this, void 0, void 0, function* () {
        yield delay(getRandomNumber(30, 200));
        return {
            id: getRandomNumber(9000, 10000),
            meta: {},
            error: null,
            warnings: [],
            prepared,
            // isFromCache: true,
        };
    });
}
export const marcosMock = [];
export const selectsMock = [
    {
        id: 'procedure_status',
        version: 1,
        created: '2025-03-12T17:45:03Z',
        modified: null,
        name: 'Procedure Status',
        title: 'PROCEDURE STATUS',
        values: [
        // { code: '', title: '' },
        ],
    },
    {
        id: 'immunization_status',
        version: 1,
        created: '2025-03-14T13:29:04Z',
        modified: null,
        name: 'Immunization status',
        title: 'Immunization status',
        freeText: null,
        preferred: null,
        values: [
            {
                code: 'completed',
                title: 'Completed',
                description: null,
            },
            {
                code: 'entered-in-error',
                title: 'Entered in error',
                description: null,
            },
            {
                code: 'not-done',
                title: 'Not Done',
                description: null,
            },
        ],
    },
];
